import { c as _c } from "react/compiler-runtime";
import { useAtom } from 'jotai';
import { metaThemeColorAtom } from '@/atoms';
import { authChangeEventAtom, userAtom } from '@/atoms/auth';
import { createClient } from '@/lib/supabase/client';
import { useAtomEffect } from '@sub-vocab/utils/hooks';
export function useAppEffects() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useAtomEffect(_temp, t0);
  useAtom(metaThemeColorAtom);
}
function _temp(_, set) {
  const supabase = createClient();
  const {
    data: t0
  } = supabase.auth.onAuthStateChange((event, session) => {
    set(authChangeEventAtom, event);
    set(userAtom, session?.user);
  });
  const {
    subscription
  } = t0;
  return () => {
    subscription.unsubscribe();
  };
}